import {createSelector} from 'reselect';
import {getLocaleFromSiteDataV2, getSettings} from '../../selectors';

const shouldShowRebrandedAdyenTrustly = createSelector(
  [getSettings, getLocaleFromSiteDataV2],
  (settings, locale) => !!settings && settings.trustly_rebrand_locales?.includes(locale),
);

export default shouldShowRebrandedAdyenTrustly;
